import { readInlineData, useLazyLoadQuery } from 'react-relay';
import { UnifiedProfileFragment$key } from 'graphql/__generated__/UnifiedProfileFragment.graphql';
import {
  UnifiedProfileQuery,
  UnifiedProfileQuery$data,
} from 'graphql/__generated__/UnifiedProfileQuery.graphql';
import { UNIFIED_PROFILE_FRAGMENT } from 'graphql/UnifiedProfileFragment';
import { UNIFIED_PROFILE_QUERY } from 'graphql/UnifiedProfileQuery';

const useIsProfileBanned = (internalId: string): boolean => {
  const unifiedProfile = useLazyLoadQuery<UnifiedProfileQuery>(
    UNIFIED_PROFILE_QUERY,
    { internalId },
    { fetchPolicy: 'store-or-network' },
  )?.unified?.unifiedProfile;

  let profileFragmentData;

  if (unifiedProfile && '__fragments' in unifiedProfile) {
    profileFragmentData = readInlineData<UnifiedProfileFragment$key>(
      UNIFIED_PROFILE_FRAGMENT,
      unifiedProfile as NonNullable<
        UnifiedProfileQuery$data['unified']
      >['unifiedProfile'],
    );
  }

  return profileFragmentData?.isProfileBanned || false;
};

export default useIsProfileBanned;
